import { googleTagManager } from './tracking';
import {
    MODEL_PAGE_GROUP,
    BUSINESS_MODEL,
    perCityLandingBusinessModel,
    trackModelPageView,
    trackModelThankYou,
} from './tracking/delivery-model-tracking';

document.addEventListener('DOMContentLoaded', async () => {
    const currentPageIsFinalFormPage = ['form_page_success', 'form_page_rejection'].some((page) =>
        window.pageGroup?.startsWith(page),
    );

    // set page group retrieved from local storage in app.blade.php
    if (currentPageIsFinalFormPage) {
        googleTagManager.setPageGroup(window.pageGroup);
    }

    // fire pageview everywhere, except form pages, as based on the form type pageGroup is adjusted
    // which happens @created hook for each form type
    if (!window.pageGroup?.includes('form') || currentPageIsFinalFormPage) {
        googleTagManager.trackPageLoaded();
    }

    // Dual model Employee + IC events (the form screens are tracked by the form itself)
    if (window.page === 'home') {
        trackModelPageView(MODEL_PAGE_GROUP.GENERAL_LANDING, null);
    } else if (perCityLandingBusinessModel()) {
        // Dual model per city: the IC and EM pages and their city pages
        trackModelPageView(MODEL_PAGE_GROUP.LANDING, perCityLandingBusinessModel());
    } else if (window.isIcLandingPage) {
        trackModelPageView(MODEL_PAGE_GROUP.LANDING, BUSINESS_MODEL.IC);
    } else if (window.location.pathname.includes('thank-you')) {
        trackModelThankYou();
    }
});
